import Link from 'next/link'

import ButtonText from '@/components/ui/Typo/ButtonText'
import Caption from '@/components/ui/Typo/Caption'
import Subtitle from '@/components/ui/Typo/Subtitle'

interface Props {
  title: string
  description: string
  icon: any
  link: string
  linkText: string
  customComponent?: any
}

const BaseCard: React.FC<Props> = ({
  description,
  icon,
  link,
  linkText,
  title,
  customComponent,
}) => {
  return (
    <div className="max-w-[420px] w-full mb-5">
      <div className="flex flex-col border rounded-lg border-gray-200 overflow-hidden w-full">
        <div className="pt-6 px-6 pb-4 flex justify-between">
          <div className="flex flex-col min-h-[160px]">
            <Subtitle>{title}</Subtitle>
            <Caption className="pt-2">{description}</Caption>
          </div>
          <div className="flex items-center justify-center ml-4">
            <div className="w-24 h-24">
              <img src={icon} alt={title} className="h-full w-auto" />
            </div>
          </div>
        </div>
        <div className="border-t border-gray-200 hover:bg-gray-50 cursor-pointer transition-colors">
          {customComponent ? (
            customComponent
          ) : (
            <Link href={link}>
              <a className="block px-6 py-4">
                <ButtonText
                  size="big"
                  color="text-secondary"
                  className="text-center"
                >
                  {linkText}
                </ButtonText>
              </a>
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}

export default BaseCard
